import React from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Box, Card, Typography } from '@mui/material';

const MANDI_LIST = [
  'Narkanda, Shimla',
  'Rohru, Shimla',
  'Shillaru APMC, Shimla',
  'Parala APMC, Shimla',
  'Kullu APMC (Bandrol)'
];

const ApplicableMandis = () => {
  return (
    <Card
      sx={{
        width: '100%',
        maxWidth: 380,
        borderRadius: 4,
        p: 2.5,
        bgcolor: 'white',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
        mx: 'auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1.5,
          mb: 2.5,
        }}
      >
        <Box
          sx={{
            flex: 1,
            height: '1px',
            background:
              'linear-gradient(90deg, transparent 0%, #E0E0E0 50%, #E0E0E0 100%)',
            maxWidth: '100px',
          }}
        />
        <Typography
          sx={{
            fontSize: '12px',
            fontFamily: 'Manrope',
            fontWeight: 500,
            lineHeight: '100%',
            letterSpacing: '0.8px',
            color: 'rgba(0, 0, 0, 0.84)',
            whiteSpace: 'nowrap',
            textTransform: 'uppercase',
            px: 1,
          }}
        >
          APPLICABLE MANDIS
        </Typography>
        <Box
          sx={{
            flex: 1,
            height: '1px',
            background:
              'linear-gradient(90deg, #E0E0E0 0%, #E0E0E0 50%, transparent 100%)',
            maxWidth: '100px',
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {MANDI_LIST.map((mandi, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <LocationOnIcon sx={{ color: '#FF4B4B' }} />
            <Typography
              variant="body1"
              sx={{
                color: '#000000',
                fontSize: '14px',
                fontFamily: 'Manrope',
                fontWeight: 500,
              }}
            >
              {mandi}
            </Typography>
          </Box>
        ))}
      </Box>
    </Card>
  );
};

export default ApplicableMandis; 